import API_BASE_URL from './config';
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import DogProfile from './DogProfile';
import Studbook from './Studbook';
import KennelRegistry from './KennelRegistry';
import MyDogs from './MyDogs';
import RegisterDog from './RegisterDog';
import MyKennels from './MyKennels';
import RegisterKennel from './RegisterKennel';
import AdminArea from './AdminArea';
import AcceptedBreeds from './AcceptedBreeds';
import BreedProfile from './BreedProfile';
import MyInventory from './MyInventory';
import ItemShop from './ItemShop';
import MyLitters from './MyLitters';
import TitlesSystem from './TitlesSystem';
import IconSubmission from './iCONSubmission';
import Achievements from './Achievements';
import MyPendingTitles from './MyPendingTitles';
import InMemoriam from './InMemoriam';
import Notifications from './Notifications';
import AdminRolling from './AdminRolling';
import AdminDogs from './AdminDogs';
import AdminKennels from './AdminKennels';
import AdminTitles from './AdminTitles';
import AdminUpdateRequests from './AdminUpdateRequests';
import AdminAPVerification from './AdminAPVerification';
import KennelProfile from './KennelProfile';
import AdminKennelImages from './AdminKennelImages';
import RegisterStaff from './RegisterStaff';
import StaffApproval from './StaffApproval';
import MyStaff from './MyStaff';
import StaffProfile from './StaffProfile';
import RegistrationGuide from './RegistrationGuide';
import LineartEditRegulations from './LineartEditRegulations';
import SkillsGuide from './SkillsGuide';
import StaffSkillSubmission from './StaffSkillSubmission';
import AdminSkills from './AdminSkills';
import WorldMapGuide from './WorldMapGuide';
import Wiki from './Wiki';
import InteractionLevels from './InteractionLevels';
import Equipment from './Equipment';
import CanineHealthTesting from './CanineHealthTesting';
import BreedingPermissions from './BreedingPermissions';
import LitterProfile from './LitterProfile';
import BreedLitter from './BreedLitter';
import TrainingSubmission from './TrainingSubmission';
import AdminTraining from './AdminTraining';
import TrainingTracker from './TrainingTracker';
import ICONMeritAdminDashboard from './ICONMeritAdminDashboard';
import MeritConfoShowAdmin from './MeritConfoShowAdmin';
import MeritConfoShowList from './MeritConfoShowList';
import ShowDetails from './ShowDetails';
import EnterIconMerit from './EnterIconMerit';
import JudgeClosedIconMerit from './JudgeClosedIconMerit';
import JudgeIconMeritEntry from './JudgeIconMeritEntry';
import Signup from './Signup';
import Login from './Login';

function App() {
  const [playerId, setPlayerId] = useState(localStorage.getItem('playerId') || '');
  const [username, setUsername] = useState(localStorage.getItem('username') || '');
  const [role, setRole] = useState(localStorage.getItem('role') || '');
  const [dfgDollars, setDfgDollars] = useState(0);

  useEffect(() => {
    if (playerId) {
      fetch(`${API_BASE_URL}/bank/${playerId}`, {
        headers: { 'player-id': playerId }
      })
        .then(res => res.ok ? res.json() : Promise.reject(`Error: ${res.status}`))
        .then(data => setDfgDollars(data.dfgDollars || 0))
        .catch(err => console.error('Bank fetch error:', err));
    }
  }, [playerId]);

  const handleLogout = () => {
    localStorage.clear();
    setPlayerId('');
    setUsername('');
    setRole('');
    setDfgDollars(0);
  };

  const formatDollars = (amount) => {
    return amount.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  };

  const navStyle = {
    padding: '15px',
    background: '#E6F0FA',
    boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
    position: 'fixed',
    top: 0,
    maxWidth: '1200px',
    width: '100%',
    margin: '0 auto',
    zIndex: 1001
  };

  const navContentStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '20px'
  };

  const linkContainerStyle = {
    backgroundColor: '#E6F0FA',
    padding: '10px 20px',
    borderRadius: '10px',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: '10px',
    alignItems: 'center'
  };

  const linkStyle = {
    textDecoration: 'none',
    color: '#1E88E5',
    fontWeight: 'bold',
    padding: '5px 10px',
    transition: 'color 0.3s'
  };

  const dropdownStyle = {
    position: 'relative',
    display: 'inline-block'
  };

  const dropdownHeaderStyle = {
    ...linkStyle,
    cursor: 'pointer'
  };

  const dropdownContentStyle = {
    display: 'none',
    position: 'absolute',
    backgroundColor: '#f9f9f9',
    minWidth: '200px',
    boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
    zIndex: 1,
    borderRadius: '5px',
    top: '100%',
    left: 0
  };

  const dropdownLinkStyle = {
    ...linkStyle,
    display: 'block',
    padding: '10px 15px',
    borderRadius: '5px'
  };

  const buttonStyle = {
    padding: '8px 15px',
    backgroundColor: '#1E88E5',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    fontWeight: 'bold',
    transition: 'background-color 0.3s'
  };

  const LandingPage = () => {
    const logoUrl = 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/b24cb081-f29c-4e75-9f36-ac033e88b0c7/djke3qh-c1b3a91c-2cc0-4c37-9d67-cb698e66ee23.png?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcL2IyNGNiMDgxLWYyOWMtNGU3NS05ZjM2LWFjMDMzZTg4YjBjN1wvZGprZTNxaC1jMWIzYTkxYy0yY2MwLTRjMzctOWQ2Ny1jYjY5OGU2NmVlMjMucG5nIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.BSQGRJBvoC8iWsmdqR1VUTS6toIKM64jVQ7aAP94T88';
    const backgroundUrl = 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/e278b58f-e271-405b-8060-c4679e13d416/djfaav3-065faecb-63c1-42ae-9ce5-0cf2e2c35167.png/v1/fill/w_894,h_894,q_70,strp/greenpatch_bg_by_dogfanciersguild_djfaav3-pre.jpg?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9OTAwIiwicGF0aCI6IlwvZlwvZTI3OGI1OGYtZTI3MS00MDViLTgwNjAtYzQ2NzllMTNkNDE2XC9kamZhYXYzLTA2NWZhZWNiLTYzYzEtNDJhZS05Y2U1LTBjZjJlMmMzNTE2Ny5wbmciLCJ3aWR0aCI6Ijw9OTAwIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmltYWdlLm9wZXJhdGlvbnMiXX0.oiwRflZAv4ZzB2J4Y8lc9yPryf3kN_Q9IlGUCMmiWI4';
    const discordUrl = 'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/e278b58f-e271-405b-8060-c4679e13d416/djfadj4-8dbc06a8-35d1-4bb6-91c3-b3ab99cb6478.png?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcL2UyNzhiNThmLWUyNzEtNDA1Yi04MDYwLWM0Njc5ZTEzZDQxNlwvZGpmYWRqNC04ZGJjMDZhOC0zNWQxLTRiYjYtOTFjMy1iM2FiOTljYjY0NzgucG5nIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.4eYGbzU_SL6rRoQmpCqgnKDH9Ni3ESeKh3wPtwtc5KU';

    return (
      <div style={{
        minHeight: '100vh',
        backgroundImage: `url(${backgroundUrl})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        padding: '20px',
        paddingTop: '150px',
        paddingBottom: '120px'
      }}>
        <div style={{
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          padding: '40px',
          borderRadius: '15px',
          boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)',
          maxWidth: '800px',
          width: '100%',
          border: '2px solid #1E88E5'
        }}>
          <img 
            src={logoUrl} 
            alt="Dog Fanciers Guild Logo" 
            style={{ 
              maxWidth: '400px', 
              width: '100%', 
              height: 'auto', 
              marginBottom: '20px' 
            }} 
          />
          <h1 style={{ 
            color: '#1E88E5',
            fontSize: '2.5em', 
            marginBottom: '20px', 
            textShadow: '1px 1px 2px rgba(0, 0, 0, 0.1)' 
          }}>
            Welcome to the Dog Fanciers Guild
          </h1>
          <p style={{ 
            color: '#333', 
            fontSize: '1.2em', 
            marginBottom: '30px', 
            lineHeight: '1.5' 
          }}>
            <span>The Dog Fanciers Guild is a DARPG club that offers an immersive user interface unlike any other, intended to augment the classic Dog Art Role Play Game Experience. The guild is compatible with many other DARPG clubs and accessible to players of all skill and experience levels. Through the Dog Fanciers Guild players can register dogs, kennels, and staff, compete in shows and events, earn titles, go on wild adventures, and so much more! For extra fun, join the DFG Discord!</span>
          </p>
          <a href="https://discord.gg/ssgn7S3U2j" target="_blank" rel="noopener noreferrer">
            <img 
              src={discordUrl} 
              alt="Join us on Discord" 
              style={{ 
                maxWidth: '200px', 
                width: '100%', 
                height: 'auto', 
                marginBottom: '30px', 
                cursor: 'pointer' 
              }} 
            />
          </a>
        </div>
        <footer style={{
          position: 'absolute',
          bottom: '-700px',
          color: '#fff',
          fontSize: '0.9em',
          textShadow: '1px 1px 2px rgba(0, 0, 0, 0.5)'
        }}>
          This website was lovingly created by Eleiria and ChrizSplash © 2025 Dog Fanciers Guild. All rights reserved.
        </footer>
      </div>
    );
  };

  return (
    <Router>
      <div style={{ fontFamily: 'Arial, sans-serif', maxWidth: '1200px', margin: '0 auto' }}>
        <nav style={navStyle}>
          <div style={navContentStyle}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
              <Link to="/">
                <img
                  src="https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/b24cb081-f29c-4e75-9f36-ac033e88b0c7/djke3qh-c1b3a91c-2cc0-4c37-9d67-cb698e66ee23.png?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcL2IyNGNiMDgxLWYyOWMtNGU3NS05ZjM2LWFjMDMzZTg4YjBjN1wvZGprZTNxaC1jMWIzYTkxYy0yY2MwLTRjMzctOWQ2Ny1jYjY5OGU2NmVlMjMucG5nIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.BSQGRJBvoC8iWsmdqR1VUTS6toIKM64jVQ7aAP94T88"
                  alt="Dog Fanciers Guild Logo"
                  style={{ height: '100px', marginRight: '20px' }}
                />
              </Link>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                {username && (
                  <span style={{ fontWeight: 'bold', fontSize: '1.1em' }}>
                    <span style={{ color: '#90CAF9' }}>Logged in as: </span>
                    <span style={{ color: '#1976D2' }}>{username} ({role})</span>
                  </span>
                )}
                <span style={{ color: '#1E88E5', fontWeight: 'bold', fontSize: '1.1em' }}>
                  DFG$: {formatDollars(dfgDollars)}
                </span>
              </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
              <div style={linkContainerStyle}>
                <div style={dropdownStyle} onMouseEnter={(e) => e.currentTarget.querySelector('.dropdown-content').style.display = 'block'} onMouseLeave={(e) => e.currentTarget.querySelector('.dropdown-content').style.display = 'none'}>
                  <span style={dropdownHeaderStyle}>Information and Guides</span>
                  <div className="dropdown-content" style={dropdownContentStyle}>
                    <Link to="/breeds" style={dropdownLinkStyle} onMouseOver={(e) => e.target.style.color = '#1976D2'} onMouseOut={(e) => e.target.style.color = '#1E88E5'}>Accepted Breeds</Link>
                    <Link to="/studbook" style={dropdownLinkStyle} onMouseOver={(e) => e.target.style.color = '#1976D2'} onMouseOut={(e) => e.target.style.color = '#1E88E5'}>Studbook</Link>
                    <Link to="/kennel-registry" style={dropdownLinkStyle} onMouseOver={(e) => e.target.style.color = '#1976D2'} onMouseOut={(e) => e.target.style.color = '#1E88E5'}>Kennel Registry</Link>
                    <Link to="/wiki" style={dropdownLinkStyle} onMouseOver={(e) => e.target.style.color = '#1976D2'} onMouseOut={(e) => e.target.style.color = '#1E88E5'}>Item Wiki</Link>
                    <Link to="/guides/registration" style={dropdownLinkStyle} onMouseOver={(e) => e.target.style.color = '#1976D2'} onMouseOut={(e) => e.target.style.color = '#1E88E5'}>Registration Guide</Link>
                    <Link to="/guides/lineart-regulations" style={dropdownLinkStyle} onMouseOver={(e) => e.target.style.color = '#1976D2'} onMouseOut={(e) => e.target.style.color = '#1E88E5'}>Lineart Edit Regulations</Link>
                    <Link to="/guides/skills" style={dropdownLinkStyle} onMouseOver={(e) => e.target.style.color = '#1976D2'} onMouseOut={(e) => e.target.style.color = '#1E88E5'}>Skills Guide</Link>
                    <Link to="/guides/world-map" style={dropdownLinkStyle} onMouseOver={(e) => e.target.style.color = '#1976D2'} onMouseOut={(e) => e.target.style.color = '#1E88E5'}>World Map</Link>
                  </div>
                </div>
                <div style={dropdownStyle} onMouseEnter={(e) => e.currentTarget.querySelector('.dropdown-content').style.display = 'block'} onMouseLeave={(e) => e.currentTarget.querySelector('.dropdown-content').style.display = 'none'}>
                  <span style={dropdownHeaderStyle}>Registration Tools</span>
                  <div className="dropdown-content" style={dropdownContentStyle}>
                    <Link to="/register-dog" style={dropdownLinkStyle} onMouseOver={(e) => e.target.style.color = '#1976D2'} onMouseOut={(e) => e.target.style.color = '#1E88E5'}>Register a Dog</Link>
                    <Link to="/register-kennel" style={dropdownLinkStyle} onMouseOver={(e) => e.target.style.color = '#1976D2'} onMouseOut={(e) => e.target.style.color = '#1E88E5'}>Register a Kennel</Link>
                    <Link to="/register-staff" style={dropdownLinkStyle} onMouseOver={(e) => e.target.style.color = '#1976D2'} onMouseOut={(e) => e.target.style.color = '#1E88E5'}>Register Staff Member</Link>
                  </div>
                </div>
                <div style={dropdownStyle} onMouseEnter={(e) => e.currentTarget.querySelector('.dropdown-content').style.display = 'block'} onMouseLeave={(e) => e.currentTarget.querySelector('.dropdown-content').style.display = 'none'}>
                  <span style={dropdownHeaderStyle}>My Stuff</span>
                  <div className="dropdown-content" style={dropdownContentStyle}>
                    <Link to="/my-dogs" style={dropdownLinkStyle} onMouseOver={(e) => e.target.style.color = '#1976D2'} onMouseOut={(e) => e.target.style.color = '#1E88E5'}>My Dogs</Link>
                    <Link to="/my-kennels" style={dropdownLinkStyle} onMouseOver={(e) => e.target.style.color = '#1976D2'} onMouseOut={(e) => e.target.style.color = '#1E88E5'}>My Kennels</Link>
                    <Link to="/my-staff" style={dropdownLinkStyle} onMouseOver={(e) => e.target.style.color = '#1976D2'} onMouseOut={(e) => e.target.style.color = '#1E88E5'}>My Staff</Link>
                    <Link to="/my-litters" style={dropdownLinkStyle} onMouseOver={(e) => e.target.style.color = '#1976D2'} onMouseOut={(e) => e.target.style.color = '#1E88E5'}>My Litters</Link>
                    <Link to="/my-inventory" style={dropdownLinkStyle} onMouseOver={(e) => e.target.style.color = '#1976D2'} onMouseOut={(e) => e.target.style.color = '#1E88E5'}>My Inventory</Link>
                    <Link to="/training-tracker" style={dropdownLinkStyle} onMouseOver={(e) => e.target.style.color = '#1976D2'} onMouseOut={(e) => e.target.style.color = '#1E88E5'}>My Training and Activity Trackers</Link>
                  </div>
                </div>
                <div style={dropdownStyle} onMouseEnter={(e) => e.currentTarget.querySelector('.dropdown-content').style.display = 'block'} onMouseLeave={(e) => e.currentTarget.querySelector('.dropdown-content').style.display = 'none'}>
                  <span style={dropdownHeaderStyle}>Activities</span>
                  <div className="dropdown-content" style={dropdownContentStyle}>
                    <Link to="/icon-submission" style={dropdownLinkStyle} onMouseOver={(e) => e.target.style.color = '#1976D2'} onMouseOut={(e) => e.target.style.color = '#1E88E5'}>iCON RNG Show</Link>
                    <Link to="/meritconfoshowlist" style={dropdownLinkStyle} onMouseOver={(e) => e.target.style.color = '#1976D2'} onMouseOut={(e) => e.target.style.color = '#1E88E5'}>iCON Merit Show</Link>
                    <Link to="/titles-system" style={dropdownLinkStyle} onMouseOver={(e) => e.target.style.color = '#1976D2'} onMouseOut={(e) => e.target.style.color = '#1E88E5'}>DFG Titles System</Link>
                    <Link to="/achievements" style={dropdownLinkStyle} onMouseOver={(e) => e.target.style.color = '#1976D2'} onMouseOut={(e) => e.target.style.color = '#1E88E5'}>Player Achievements</Link>
                    <Link to="/skill-submission" style={dropdownLinkStyle} onMouseOver={(e) => e.target.style.color = '#1976D2'} onMouseOut={(e) => e.target.style.color = '#1E88E5'}>Staff Skill Submission</Link>
                    <Link to="/health-testing" style={dropdownLinkStyle} onMouseOver={(e) => e.target.style.color = '#1976D2'} onMouseOut={(e) => e.target.style.color = '#1E88E5'}>Canine Health Testing</Link>
                    <Link to="/breeding-permissions" style={dropdownLinkStyle} onMouseOver={(e) => e.target.style.color = '#1976D2'} onMouseOut={(e) => e.target.style.color = '#1E88E5'}>Manage Breeding Permissions</Link>
                    <Link to="/breed-litter" style={dropdownLinkStyle} onMouseOver={(e) => e.target.style.color = '#1976D2'} onMouseOut={(e) => e.target.style.color = '#1E88E5'}>Breed a Litter</Link>
                    <Link to="/training-submission" style={dropdownLinkStyle} onMouseOver={(e) => e.target.style.color = '#1976D2'} onMouseOut={(e) => e.target.style.color = '#1E88E5'}>Training Submission</Link>
                  </div>
                </div>
                <Link to="/item-shop" style={linkStyle} onMouseOver={(e) => e.target.style.color = '#1976D2'} onMouseOut={(e) => e.target.style.color = '#1E88E5'}>Item Shop</Link>
                {role.toLowerCase() === 'admin' && (
                  <Link to="/admin" style={linkStyle} onMouseOver={(e) => e.target.style.color = '#1976D2'} onMouseOut={(e) => e.target.style.color = '#1E88E5'}>Admin Area</Link>
                )}
                {playerId ? (
                  <button 
                    onClick={handleLogout} 
                    style={buttonStyle}
                    onMouseOver={(e) => e.target.style.backgroundColor = '#1976D2'}
                    onMouseOut={(e) => e.target.style.backgroundColor = '#1E88E5'}
                  >
                    Logout
                  </button>
                ) : (
                  <>
                    <Link to="/login">
                      <button
                        style={buttonStyle}
                        onMouseOver={(e) => e.target.style.backgroundColor = '#1976D2'}
                        onMouseOut={(e) => e.target.style.backgroundColor = '#1E88E5'}
                      >
                        Login
                      </button>
                    </Link>
                    <Link to="/signup">
                      <button
                        style={buttonStyle}
                        onMouseOver={(e) => e.target.style.backgroundColor = '#1976D2'}
                        onMouseOut={(e) => e.target.style.backgroundColor = '#1E88E5'}
                      >
                        Signup
                      </button>
                    </Link>
                  </>
                )}
              </div>
              {playerId && <Notifications playerId={playerId} />}
            </div>
          </div>
        </nav>

        <div style={{ padding: '20px', paddingTop: '150px' }}>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/signup" element={<Signup setPlayerId={setPlayerId} setUsername={setUsername} setRole={setRole} />} />
            <Route path="/login" element={<Login setPlayerId={setPlayerId} setUsername={setUsername} setRole={setRole} />} />
            <Route path="/breeds" element={<AcceptedBreeds />} />
            <Route path="/breeds/:breedCode" element={<BreedProfile />} />
            <Route path="/studbook" element={<Studbook />} />
            <Route path="/kennel-registry" element={<KennelRegistry />} />
            <Route path="/dog/:dogId" element={<DogProfile />} />
            <Route path="/kennel/:kennelId" element={<KennelProfile />} />
            <Route path="/staff/:staffId" element={<StaffProfile />} />
            <Route path="/litter/:litterId" element={<LitterProfile playerId={playerId} />} />
            <Route path="/guides/registration" element={<RegistrationGuide />} />
            <Route path="/guides/lineart-regulations" element={<LineartEditRegulations />} />
            <Route path="/guides/skills" element={<SkillsGuide />} />
            <Route path="/guides/world-map" element={<WorldMapGuide />} />
            <Route path="/wiki" element={<Wiki />} />
            <Route path="/my-dogs" element={<MyDogs playerId={playerId} />} />
            <Route path="/register-dog" element={<RegisterDog playerId={playerId} />} />
            <Route path="/my-kennels" element={<MyKennels playerId={playerId} />} />
            <Route path="/register-kennel" element={<RegisterKennel playerId={playerId} />} />
            <Route path="/my-staff" element={<MyStaff playerId={playerId} />} />
            <Route path="/register-staff" element={<RegisterStaff playerId={playerId} />} />
            <Route path="/my-inventory" element={<MyInventory playerId={playerId} />} />
            <Route path="/item-shop" element={<ItemShop playerId={playerId} />} />
            <Route path="/my-litters" element={<MyLitters playerId={playerId} />} />
            <Route path="/breed-litter" element={<BreedLitter playerId={playerId} />} />
            <Route path="/titles-system" element={<TitlesSystem playerId={playerId} />} />
            <Route path="/icon-submission" element={<IconSubmission playerId={playerId} />} />
            <Route path="/achievements" element={<Achievements playerId={playerId} />} />
            <Route path="/my-pending-titles" element={<MyPendingTitles playerId={playerId} />} />
            <Route path="/in-memoriam/:playerId" element={<InMemoriam />} />
            <Route path="/skill-submission" element={<StaffSkillSubmission playerId={playerId} />} />
            <Route path="/dog/:dogId/interaction-levels" element={<InteractionLevels />} />
            <Route path="/dog/:dogId/equipment" element={<Equipment />} />
            <Route path="/health-testing" element={<CanineHealthTesting playerId={playerId} />} />
            <Route path="/breeding-permissions" element={<BreedingPermissions playerId={playerId} />} />
            <Route path="/training-submission" element={<TrainingSubmission playerId={playerId} />} />
            <Route path="/training-tracker" element={<TrainingTracker playerId={playerId} />} />
            <Route path="/meritconfoshowlist" element={<MeritConfoShowList playerId={playerId} />} />
            <Route path="/merit-confo/show/:id" element={<ShowDetails playerId={playerId} />} />
            <Route path="/merit-confo/show/:id/enter" element={<EnterIconMerit />} />
            {role.toLowerCase() === 'admin' && (
              <>
                <Route path="/admin" element={<AdminArea adminId={playerId} />} />
                <Route path="/admin/dogs" element={<AdminDogs />} />
                <Route path="/admin/kennels" element={<AdminKennels />} />
                <Route path="/admin/kennel-images" element={<AdminKennelImages />} />
                <Route path="/admin/titles" element={<AdminTitles />} />
                <Route path="/admin/update-requests" element={<AdminUpdateRequests />} />
                <Route path="/admin/verify-ap" element={<AdminAPVerification playerId={playerId} />} />
                <Route path="/admin-rolling" element={<AdminRolling adminId={playerId} />} />
                <Route path="/admin/staff-approval" element={<StaffApproval />} />
                <Route path="/admin/skills" element={<AdminSkills />} />
                <Route path="/admin/training" element={<AdminTraining adminId={playerId} />} />
                <Route path="/merit-confo/admin" element={<ICONMeritAdminDashboard />} />
                <Route path="/merit-confo/show/:showId/admin" element={<MeritConfoShowAdmin />} />
                <Route path="/merit-confo/shows" element={<MeritConfoShowList />} />
                <Route path="/judge-closed-icon-merit" element={<JudgeClosedIconMerit />} />
                <Route path="/judge-icon-merit/:showId" element={<JudgeIconMeritEntry />} />
              </>
            )}
            <Route path="*" element={<LandingPage />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;